import { Injectable } from '@angular/core';
import {AccessibilityStatementProxy} from "./accessibility.statement.proxy";
import {HttpObservable} from "../../http-helpers/http.wrapper";

@Injectable({
  providedIn: 'root'
})
export class AccessibilityStatementService {
  constructor(private accessibilityStatementProxy: AccessibilityStatementProxy) {
  }

  public getAccessibilityStatement(languageKey: number): HttpObservable<string> {
    return this.accessibilityStatementProxy.getAccessibilityStatement(languageKey);
  }
}
